import { QueryParams } from './global.type'

export type CustomOptions = RequestInit & {
  baseUrl?: string | undefined
  query?: QueryParams | undefined | any
  headers?: HeadersInit & {
    'client-key'?: string | undefined
    Authorization?: string | undefined
  }
}

export type EntityErrorPayload = {
  message: string
  error: { [key: string]: string }
}

export class HttpError extends Error {
  status: number
  payload: {
    message: string
    [key: string]: string | number | boolean | object
  }
  constructor({ status, payload }: { status: number; payload: { message: string; [key: string]: string | number | boolean | object } }) {
    super('Http error')
    this.status = status
    this.payload = payload
  }
}

export class EntityError extends HttpError {
  status: 422
  payload: EntityErrorPayload
  constructor({ status, payload }: { status: 422; payload: EntityErrorPayload }) {
    super({ status, payload })
    this.status = status
    this.payload = payload
  }
}

export class SessionToken {
  private token = ''
  get value() {
    return this.token
  }
  set value(token: string) {
    this.token = token
  }
}
